import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";

// Connects to data-controller="datagrids--filter"
export default class extends Controller {
  connect() {
    this._cleanupCachedWidgets()
    this._initDatepicker()
    this._initSelect2()
  }

  _cleanupCachedWidgets() {
    this.element.querySelectorAll('form.datagrid-form input[readonly][type="text"]').forEach((input) => {
      input.remove()
    })

    this.element.querySelectorAll('form.datagrid-form .date_filter, form.datagrid-form .date_time_filter').forEach((el) => {
      if (el._flatpickr) {
        el._flatpickr.destroy()
      }
    })

    this.element.querySelectorAll('form.datagrid-form .select2-container').forEach((container) => {
      container.remove()
    })

    this.element.querySelectorAll('form.datagrid-form select.select2').forEach((el) => {
      if ($(el).hasClass('select2-hidden-accessible')) {
        $(el).select2('destroy')
      }
    })
  }

  _initSelect2() {
    this.element.querySelectorAll('form.datagrid-form select.select2').forEach((el) => {
      $(el).select2({})
    })
  }

  _initDatepicker() {
    const adjustAltInput = (el, instance) => {
      const alt = instance.altInput
      if (alt) {
        const aria = el.getAttribute("aria-label")
        if (aria) alt.setAttribute("aria-label", aria)
      }
    }

    this.element.querySelectorAll('form.datagrid-form .date_filter').forEach((el) => {
      flatpickr(el, {
        locale: 'en',
        enableTime: false,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
        onReady: (selectedDates, dateStr, instance) => adjustAltInput(el, instance)
      })
    })

    this.element.querySelectorAll('form.datagrid-form .date_time_filter:not(.from):not(.to)').forEach((el) => {
      flatpickr(el, {
        locale: 'en',
        enableTime: true,
        minuteIncrement: 1,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "m/d/Y G:i K",
        onReady: (selectedDates, dateStr, instance) => adjustAltInput(el, instance)
      })
    })

    this.element.querySelectorAll('form.datagrid-form .date_time_filter.from').forEach((el) => {
      flatpickr(el, {
        locale: 'en',
        enableTime: true,
        minuteIncrement: 1,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "m/d/Y G:i K",
        defaultHour: 0,
        onReady: (selectedDates, dateStr, instance) => adjustAltInput(el, instance)
      })
    })

    this.element.querySelectorAll('form.datagrid-form .date_time_filter.to').forEach((el) => {
      flatpickr(el, {
        locale: 'en',
        enableTime: true,
        minuteIncrement: 1,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "m/d/Y G:i K",
        defaultHour: 23,
        defaultMinute: 59,
        onReady: (selectedDates, dateStr, instance) => adjustAltInput(el, instance)
      })
    })
  }
}
